import React, {FC, useCallback} from 'react';
import MenuItem from '@mui/material/MenuItem';
import EnsurePermission from './EnsurePermission';
import Tooltip from '@mui/material/Tooltip';

export interface ListOptionConfig {
  name: string,
  disabled?: boolean,
  tooltipMessage?: string | boolean,
  onClick: () => void,
  Icon?: any,
  permission?: Nullable<string[]>
}

interface ListOptionsItemProps extends ListOptionConfig {
  handleClose: () => void
}

const ListOptionsItem: FC<ListOptionsItemProps> = ({
  onClick,
  disabled,
  Icon,
  name,
  tooltipMessage,
  permission,
  handleClose
}) => {
  const handleClick = useCallback(() => {
    onClick();
    handleClose();
  }, [onClick, handleClose]);

  const Item = (
    <MenuItem
      onClick={handleClick}
      disabled={disabled}
      classes={{
        root: 'menu__item'
      }}
    >
      {Icon && <Icon fontSize="small" className="menu__icon" />}
      {name}
    </MenuItem>
  );

  return (
    <EnsurePermission
      key={name}
      elementPermissions={permission}
    >
      {tooltipMessage ? (
        <Tooltip title={tooltipMessage} placement="left">
          <div>
            {Item}
          </div>
        </Tooltip>
      ) : Item}
    </EnsurePermission>
  );
};

export default ListOptionsItem;
